import React from 'react';

export default function ProfitAndLoss() {
  return (
    <div>
      Profit and loss
    </div>
  );
}